import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { TrackOnClick } from "../../host/TrackOnClick";

export interface ExportButtonProps {
  /** Stream the rows currently in view (members or invitations, depending on
   *  the active tab) to the browser as a CSV download. */
  onExport: () => void;
  /** Disable Export while the active tab's rows are still loading — exporting
   *  mid-fetch would write an empty/partial CSV. */
  disabled?: boolean;
}

// Sits at the top-left of the table (above the members/invitations grid) per
// the AhaSlides Team design. Split out of ActionButtons so the toolbar row
// keeps only the tab-level actions (Buy licences / Invite) while Export lives
// with the table it acts on.
export function ExportButton({ onExport, disabled }: ExportButtonProps) {
  const { t } = useTranslation();

  return (
    <TrackOnClick name="export-team-csv-button">
      <Button
        icon={<DownloadOutlined />}
        onClick={onExport}
        disabled={disabled}
        data-testid="my-team-export-button"
      >
        {t("team.action.export")}
      </Button>
    </TrackOnClick>
  );
}
